import { pushEvent } from './dataLayer'
import { trackEvent, setUserProperties } from './amplitude'

export { captureUTMs, getStoredUTMs } from './utm'
export { getVisitorStatus } from './visitor'
export { setUserProperties }

export const track = (eventName: string, params: Record<string, unknown> = {}) => {
  pushEvent(eventName, params)
  trackEvent(eventName, params)
}
